import coreAbi from './core.json'

const Core = { abi: coreAbi, addr: "0xfC9ec868f4c8c586D1BB7586870908CCa53D5F38" }

export default { Core }